import { render, staticRenderFns } from "./DemoBlock.vue?vue&type=template&id=ef59a88a&scoped=true"
import script from "./DemoBlock.vue?vue&type=script&lang=js"
export * from "./DemoBlock.vue?vue&type=script&lang=js"
import style0 from "./DemoBlock.vue?vue&type=style&index=0&id=ef59a88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef59a88a",
  null
  
)

export default component.exports